import React, { useRef, useState } from 'react';
import { Spin, Modal, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import printIcon from '../../assets/print-icon.png';
import './printBoard.css';
import { useReactToPrint } from 'react-to-print';
import { useDocument } from '../../context/documentInfoContex';

const PrintBoard = () => {
    const { isTemplateDocument } = useDocument();
    const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

    const handlePrint = useReactToPrint({
        content: () => document.getElementById('my-canvas-board'),
        onBeforeGetContent: () => {
            setIsGeneratingPreview(true);
            return new Promise((resolve) => {
                setTimeout(() => {
                    setIsGeneratingPreview(false);
                    resolve();
                }, 1000);
            });
        },
        onAfterPrint: () => { setIsGeneratingPreview(false); }
    });

    return (
        <div>
            <Tooltip title='Print'>
                <div onClick={handlePrint} style={{ cursor: 'pointer', marginLeft: isTemplateDocument ? "0px" : "8px" }}>
                    <img src={printIcon} width={22} alt="Print" />
                </div>
            </Tooltip>
            <Modal
                title="Generating preview"
                visible={isGeneratingPreview}
                closable={false}
                footer={null}
                width={240}
                centered
                style={{ borderRadius: '8px', width: '150px' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p style={{ marginBottom: '10px' }}>This may take a few moments</p>
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 28,
                                    fontWeight: 'bold',
                                    color: 'black'
                                }}
                                spin
                            />
                        }
                    />
                </div>
            </Modal>
        </div>
    );
};

export default PrintBoard;